import AutoNumeric from "autonumeric";

const autonumericOptions = {
    digitGroupSeparator: ' ',
    decimalCharacter: ',',
    decimalCharacterAlternative: '.',
    decimalPlaces: 2,
    currencySymbol: "€ ",
    unformatOnSubmit: true,
    negativePositiveSignPlacement: 'r',
    modifyValueOnWheel: false
}

function initCurrencyInput(el) {
    new AutoNumeric(el, autonumericOptions);
}

const autonumericPercentageOptions = {
    suffixText: '%',
    digitGroupSeparator: ' ',
    decimalCharacter: ',',
    decimalCharacterAlternative: '.',
    decimalPlaces: 2,
    // maximumValue: '100',
    // minimumValue: '0',
    modifyValueOnWheel: false,
    unformatOnSubmit: true
}

function initPercentageInput(el, refresh = false) {
    const i = new AutoNumeric(el, autonumericPercentageOptions);
    const myEl = $(el)
    const otherPercentage = myEl.closest('.has-many-container').find(`input[id^=journal_entry_amount_shares_attributes_][id$=percentage]:not(#${myEl.attr('id')})`);
    let currentTot = 100
    $.each(otherPercentage, function () {
        const anInstance = AutoNumeric.getAutoNumericElement(this);
        if (anInstance) {
            currentTot -= anInstance.getNumber();
        }
    })
    if (refresh) {
        i.set(currentTot < 0 ? 0 : currentTot)
        myEl.trigger('change.sync-per-am')
    }

}
export { autonumericPercentageOptions, autonumericOptions, initCurrencyInput, initPercentageInput }